import { GET_CLIENT_PERMISSION, GET_CLIENT_PERMISSION_ERROR } from "../../actions/types";

const initialState = {
    clientPermission: {},
}

export const clientPermission = (state = initialState, action) => {
    switch (action.type) {
        case GET_CLIENT_PERMISSION:
            return {
                ...state,
                clientPermission: action.payload.data,
            };
        case GET_CLIENT_PERMISSION_ERROR:
            return {
                ...state,
                clientPermission: {},
            };
        default:
            return state;
    }
}